define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.push;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/push.js
// module id = GUxi
// module chunks = 0 1